var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('Loader'):_vm._e(),(_vm.isApplicationLoaded)?_c('div',{staticClass:"template"},[_c('Home',{key:_vm.betgamesIframeUrlData.partnerToken})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }